import React, { useState } from 'react';
import { LoaderCircle, CircleCheck, ThumbsUp, ThumbsDown } from 'lucide-react';

interface DocumentReviewButtonProps {
  initialLabel: string;
  loadingLabel: string;
  successLabel: string;
  colorClass: string;
  successColorClass: string;
  onClick?: () => void;
  id: string;
  showLoader?: boolean;
  showIcons?: boolean;
  icon?: string;
  disabled?: boolean; 
}

const DocumentReviewButton: React.FC<DocumentReviewButtonProps> = ({
  initialLabel,
  loadingLabel,
  successLabel,
  colorClass,
  successColorClass,
  onClick,
  showLoader = true,
  showIcons = true,
  icon,
  disabled = false, // Default value is false
}) => {
  const [state, setState] = useState<'initial' | 'loading' | 'success'>(
    'initial'
  );

  const handleClick = () => {
    if (disabled || state === 'loading') return; // Prevent click if disabled or loading
    if (onClick) {
      onClick();
    } else {
      setState('loading');
      setTimeout(() => {
        setState('success');
      }, 2000); // Simulating an asynchronous action
    }
  };

  // Determine the current label based on the state
  const currentLabel =
    state === 'loading'
      ? loadingLabel
      : state === 'success'
      ? successLabel
      : initialLabel;

  // Determine the icon based on the initialLabel
  const defaultIcon =
    initialLabel === 'Passed Quality Check' ? (
      <ThumbsUp className="m-[10px] mr-2" size={15} />
    ) : (
      <ThumbsDown className="m-[10px] mr-2" size={15} />
    );

  return (
    <button
      className={`w-full h-18 py-4 px-6 rounded ${
        state === 'success' ? successColorClass : colorClass
      } opacity-${disabled ? '50' : '100'} flex items-center justify-center transition-opacity duration-300`}
      onClick={handleClick}
      disabled={disabled || state === 'loading'} 
    >
      {state === 'loading' && showLoader && (
        <LoaderCircle size={18} className="animate-spin mr-2" />
      )}
      {showIcons && icon ? (
        <img src={icon} className="me-2" />
      ) : showIcons ? (
        defaultIcon
      ) : (
        ''
      )}
      {currentLabel}
      {state === 'success' && <CircleCheck className="m-[10px]" size={15} />}
    </button>
  );
};

export default DocumentReviewButton;
